// src/CuteFrame.js
import React from 'react';
import { alert_error , alert_success } from '../../../AppContext';
const Copycmtmaps = ({ text }) => {
    function saochep(value) {
        alert_success('Đã sao chép') ;
        window.saochepnative(value);
      };
  return (
    <div className="flex justify-center items-center">
      <button onClick={() => saochep(text)} className="bg-pink-200 p-1 w-full rounded-lg shadow-md">
      <div className="text-lg text-center font-bold text-purple-700">{text}</div>
      <div className="flex justify-between mt-0">
          <div className="text-xs text-right text-white">Hướng dẫn</div>
          <div className="text-xs text-left text-white">Ấn đây để sao chép</div>
        </div>
      </button>
    </div>
  );
};

export default Copycmtmaps;
